/**
 * 区分 jobType（jobs.job_type）
 * 出典：02 D-092（batch のジョブは batch_job_type をそのまま使う）
 */
export const JOB_TYPE_VALUES = [
  'export',
  'import',
  'bulkDelete',
  'restore',
  'monthlyChecklistGeneration',
  'dailyAggregation',
  'contractExpiryAlert',
  'overdueChecklistTaskNotice',
  'myNumberRetentionPurge',
  'pitrExport',
  'batchWatchdog',
  'capacityWatch',
] as const;

export type JobType = (typeof JOB_TYPE_VALUES)[number];

export const JOB_TYPE_LABELS: Readonly<Record<JobType, string>> = {
  export: '出力',
  import: '取込',
  bulkDelete: '一括削除',
  restore: '復元',
  monthlyChecklistGeneration: '月初チェックリスト生成',
  dailyAggregation: '日次集計の突合',
  contractExpiryAlert: '契約期限アラート',
  overdueChecklistTaskNotice: '期限切れタスク通知',
  myNumberRetentionPurge: 'マイナンバー保管期限削除',
  pitrExport: 'PITR Export',
  batchWatchdog: 'バッチの見張り',
  capacityWatch: '容量監視',
};
